.voided-label-section {
  border-color: var(--default--border-color--15);
}
